var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCountry = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00065 1.83301C4.59489 1.83301 1.83398 4.59392 1.83398 7.99967C1.83398 11.4054 4.59489 14.1663 8.00065 14.1663C11.4064 14.1663 14.1673 11.4054 14.1673 7.99967C14.1673 4.59392 11.4064 1.83301 8.00065 1.83301ZM0.833984 7.99967C0.833984 4.04163 4.04261 0.833008 8.00065 0.833008C11.9587 0.833008 15.1673 4.04163 15.1673 7.99967C15.1673 11.9577 11.9587 15.1663 8.00065 15.1663C4.04261 15.1663 0.833984 11.9577 0.833984 7.99967Z",
    fill: "#78829D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.83372 2C4.83372 1.72386 5.05758 1.5 5.33372 1.5H6.00039C6.16116 1.5 6.31212 1.5773 6.40609 1.70775C6.50006 1.83819 6.52557 2.00587 6.47465 2.15836C5.20897 5.94891 5.20897 10.0511 6.47465 13.8416C6.52557 13.9941 6.50006 14.1618 6.40609 14.2923C6.31212 14.4227 6.16116 14.5 6.00039 14.5H5.33372C5.05758 14.5 4.83372 14.2761 4.83372 14C4.83372 13.7287 5.04982 13.5079 5.31928 13.5002C4.26076 9.91074 4.26076 6.08926 5.31928 2.4998C5.04982 2.49215 4.83372 2.27131 4.83372 2Z",
    fill: "#78829D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.84178 1.52588C10.1037 1.43842 10.3869 1.57985 10.4744 1.84178C11.8087 5.83789 11.8087 10.1624 10.4744 14.1585C10.3869 14.4204 10.1037 14.5619 9.84178 14.4744C9.57985 14.3869 9.43842 14.1037 9.52588 13.8418C10.7916 10.0512 10.7916 5.94904 9.52588 2.15849C9.43842 1.89657 9.57985 1.61333 9.84178 1.52588Z",
    fill: "#78829D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.70775 9.59431C1.83819 9.50034 2.00587 9.47483 2.15836 9.52574C5.94891 10.7914 10.0511 10.7914 13.8416 9.52574C13.9941 9.47483 14.1618 9.50034 14.2923 9.59431C14.4227 9.68828 14.5 9.83924 14.5 10V10.6667C14.5 10.9428 14.2761 11.1667 14 11.1667C13.7287 11.1667 13.5079 10.9506 13.5002 10.6811C9.91074 11.7396 6.08926 11.7396 2.4998 10.6811C2.49215 10.9506 2.27131 11.1667 2 11.1667C1.72386 11.1667 1.5 10.9428 1.5 10.6667V10C1.5 9.83924 1.5773 9.68828 1.70775 9.59431Z",
    fill: "#78829D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8418 6.47465C10.0512 5.20897 5.94904 5.20897 2.15849 6.47465C1.89657 6.56211 1.61333 6.42068 1.52588 6.15875C1.43842 5.89682 1.57985 5.61359 1.84178 5.52613C5.83789 4.19181 10.1624 4.19181 14.1585 5.52613C14.4204 5.61359 14.5619 5.89682 14.4744 6.15875C14.3869 6.42068 14.1037 6.56211 13.8418 6.47465Z",
    fill: "#78829D"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCountry);
export default ForwardRef;